
    import { computed, defineComponent } from 'vue'

    import { radioStation } from '@/common/json-ld/organization'
    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        props: {
            privacyPolicy: {
                type: Boolean,
                default: false
            }
        },

        setup () {
            const settingsStore = useSharedSettingsStore()
            const city = computed(() => settingsStore.setting('contact-city'))
            const mail = computed(() => `mailto:${settingsStore.setting('contact-mail')}`)
            const postalCode = computed(() => settingsStore.setting('contact-postal-code'))
            const street = computed(() => settingsStore.setting('contact-street'))
            const jsonLd = radioStation()

            return {
                city,
                jsonLd,
                mail,
                postalCode,
                street
            }
        }
    })
